module.exports = __webpack_public_path__ + "img/thumbnail_GreySeal_m_albino.40ebe2bd.png";